export default "__VITE_ASSET__CZLCeFvp__"